import React from "react";

const SavedPostsLimitWarning = ({ savedPostsCount }) => {
  // Nếu số lượng bài viết đã lưu dưới 14, không hiển thị cảnh báo
  if (savedPostsCount < 14) {
    return null;
  }

  // Xác định thông báo dựa trên số lượng bài viết đã lưu
  let warningMessage = "";
  let bgColor = "bg-yellow-50";
  let borderColor = "border-yellow-200";
  let textColor = "text-yellow-600";

  if (savedPostsCount >= 20) {
    warningMessage = `Bạn đã lưu tối đa 20/20 bài viết. Vui lòng xóa bớt bài viết cũ trong trang Hồ sơ để có thể lưu thêm bài viết mới.`;
    bgColor = "bg-red-50";
    borderColor = "border-red-200";
    textColor = "text-red-600";
  } else if (savedPostsCount >= 16) {
    warningMessage = `Bạn đã lưu ${savedPostsCount}/20 bài viết. Sắp đạt giới hạn tối đa!`;
    bgColor = "bg-orange-50";
    borderColor = "border-orange-200";
    textColor = "text-orange-600";
  } else {
    warningMessage = `Bạn đã lưu ${savedPostsCount}/20 bài viết. Mỗi tài khoản chỉ có thể lưu tối đa 20 bài viết.`;
  }

  return (
    <div className="flex justify-center">
      <div
        className={`mb-4 p-4 ${bgColor} border ${borderColor} rounded-md inline-block`}
      >
        <p className={`${textColor} font-medium text-center`}>
          {warningMessage}
        </p>
      </div>
    </div>
  );
};

export default SavedPostsLimitWarning;
